export function convertCamelCaseToText(text) {
  try {
    if (text) {
      return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    } else {
      return ""
    }
  } catch (error) {
    console.log(error)
  }
}

// Convert a display name into an UPPER_SNAKE_CASE key.
// e.g. "Scholarship Application Submitted" -> "SCHOLARSHIP_APPLICATION_SUBMITTED"
export function toUpperSnakeKey(text) {
  if (!text) return ""
  return text
    .toString()
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_") // any non-alphanumeric run -> single underscore
    .replace(/^_+|_+$/g, "") // trim leading/trailing underscores
}
